var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"responsive w-12 h-12",attrs:{"alt":_vm.alt,"src":_vm.src},on:{"error":_vm.setAltImg}})
}
var staticRenderFns = []

export { render, staticRenderFns }